export default "__VITE_ASSET__2ec82c2e__"